<template>
  <button @click="toggleFavorite" class="btn btn-outline-danger btn-favorite">
    <i class="bi" :class="isFavorite ? 'bi-heart-fill' : 'bi-heart'"></i>
  </button>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FavoriteButton',
  props: {
    productId: {
      type: Number,
      required: true
    },
    initialFavoriteStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFavorite: this.initialFavoriteStatus,
      isProcessing: false
    }
  },
  mounted() {
    this.checkFavoriteStatus();
  },
  methods: {
    async checkFavoriteStatus() {
      try {
        const response = await axios.get(`/api/favorites/check/${this.productId}`);
        // Check if response has the new format with status property
        if (response.data && typeof response.data.status !== 'undefined') {
          this.isFavorite = response.data.status;
        } else {
          // Fallback for backward compatibility - check if response.data is not empty
          // Empty objects {} should be treated as not favorited
          this.isFavorite = response.data && Object.keys(response.data).length > 0;
        }
      } catch (error) {
        console.error('Error checking favorite status:', error);
        this.isFavorite = false;
      }
    },
    async toggleFavorite() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      
      try {
        if (this.isFavorite) {
          await axios.delete(`/api/favorites/${this.productId}`);
        } else {
          await axios.post('/api/favorites', {
            product_id: this.productId
          });
        }
        
        this.isFavorite = !this.isFavorite;
        this.$emit('favorite-changed', this.isFavorite);
      } catch (error) {
        console.error('Error toggling favorite:', error);
        
        if (error.response && error.response.status === 401) {
          // User is not authenticated, redirect to login
          window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
        } else {
          // If there's an error but the action was to remove a favorite,
          // we should still update the UI as if it worked
          if (this.isFavorite) {
            this.isFavorite = false;
            this.$emit('favorite-changed', false);
          } else {
            alert('Der opstod en fejl. Prøv igen senere.');
          }
        }
      } finally {
        this.isProcessing = false;
      }
    }
  }
}
</script>

<style scoped>
.btn-favorite {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: #fff;
  color: #dc3545;
  border: 1px solid #dc3545;
  transition: all 0.2s ease;
  padding: 0;
}

.btn-favorite:hover {
  background-color: #fdf1f2;
  color: #dc3545;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-favorite i {
  color: #dc3545;
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}

.btn-favorite:active i {
  transform: scale(1.3);
}
</style>
